import axios from "axios";
import { setHeaders } from "../../../utils/basic";
import { useQuery } from 'react-query';
import * as config from "../../../app.config";

const getRptIds = async () => {

    const headerConfig = setHeaders();

    const { data } = await axios
        .get(`${config.ENDPOINTS["datalake"]}/list/mfg_reports`, {
            headers: headerConfig
        });

    return data;
};

export default function useFetchRpt() {
    return useQuery("viewrpt", getRptIds);
}
